import { fetchData } from "@client";

export async function fetchProjectProposalQuery(shareLink) {
  const res = await fetchData(`/project/sharelink/${shareLink}`);

  return res.results;
}
